/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeFilter\StepElement\StepElement.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday March 2nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday March 2nd 2023 5:42:26 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from 'Content/Filters/ButtonFilter/StepElement/StepElement.module.css';
import getCatIconToDisplay from 'Utils/GetCatIconToDisplay';
import getEnergyToDisplay from 'Utils/GetEnergyToDisplay';
import getBrandToDisplay from 'Utils/GetBrandToDisplay';
import ParagrapheStyled from 'Theme/Component/Paragraphe';

type StepElementType ={
    elem: string,
    themeColor: string,
    nextStep: Function,
    setNextFunction?: Function,
    trad?: string,
    isCat?: boolean,
    isEnergy?: boolean,
    isBrand?: boolean,
};

function StepElement(props: StepElementType){
    let myReactNode;
    if (props.isCat)
        myReactNode = getCatIconToDisplay(props.elem.toLowerCase(), {fill:"rgba(0,0,0,0)", height:"100%", stroke:"#f1a200", strokeWidth:"30px"});
    if(props.isEnergy)
        myReactNode = getEnergyToDisplay(props.elem.toLowerCase(),{fill:"#fff", width:"3rem"} );
    if(props.isBrand)
        myReactNode = getBrandToDisplay(props.elem.toLowerCase(),{fill:"#fff"});

    return (
        <React.Fragment>
            {
                <ParagrapheStyled bgColor={props.themeColor}>
                    <button className={`${styles.step}`} onClick={() => props.nextStep(props.elem, props.setNextFunction)}>
                        {myReactNode}
                        <div className={`${ !props.isEnergy ? styles.stepText:"" }`}>
                            {props.trad == undefined ? <p className={`${styles.resetP}`}>{props.elem.toUpperCase()}</p> : <p className={`${styles.resetP}`}> {translator.decode(`${props.trad}.${(props.elem).toLowerCase()}`).toUpperCase()}</p>}
                        </div>
                    </button>
                </ParagrapheStyled>
            }
        </React.Fragment>
    )
}

export default StepElement;
